if (!customElements.get('pf-card-buy')) {
  class PFCardBuy extends HTMLElement {
    connectedCallback() {
      this.pills = this.querySelectorAll('input[type="radio"]');
      this.variantInput = this.querySelector('.pf-variant-id');
      this.addBtn = this.querySelector('.pf-add-to-cart');
      this.buyBtn = this.querySelector('.pf-buy-now');
      this.priceEl = this.closest('.card__information')
        ? this.closest('.card__information').querySelector('.price')
        : null;

      this.pills.forEach((pill) => {
        pill.addEventListener('change', this.onChange.bind(this));
      });
    }

    onChange(event) {
      const pill = event.currentTarget;
      const variantId = pill.dataset.variantId;
      const price = pill.dataset.variantPrice;
      const available = pill.dataset.variantAvailable === 'true';

      if (this.variantInput) this.variantInput.value = variantId;

      if (this.priceEl) {
        const regular = this.priceEl.querySelector('.price-item--regular');
        if (regular) regular.textContent = price;
      }

      [this.addBtn, this.buyBtn].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !available;
      });

      if (this.addBtn) {
        const label = this.addBtn.querySelector('[data-add-label]');
        if (label) {
          label.textContent = available
            ? this.addBtn.dataset.addLabel
            : this.addBtn.dataset.soldOutLabel;
        }
      }
    }
  }

  customElements.define('pf-card-buy', PFCardBuy);
}
